import template from './NotificationsItemView.hbs';
import {BaseView, Prototype} from '../../../BaseView';
import {AggregatedUserNotificationModel} from '../../../../model/notifications/AggregatedUserNotificationModel';
import {FARMS} from '../../../../../js/resources/SessionObjects';
import {router} from '../../../../../js/router';
import {SessionStorageUtil} from '../../../../utils/SessionStorageUtil';

/**
 * @class NotificationsItemView
 * @extends BaseView
 *
 * @param {AggregatedUserNotificationModel} model
  */
@Prototype({
    template,
    className: 'notifications-list__item',
    ui: {
    },
    events: {
        'click': 'onClick'
    },
})
export class NotificationsItemView extends BaseView {

    serializeData () {
        let data = this.model.toViewJSON();
        return _.extend({}, data, {
            description: data.description.replace(/&amp;/g, '&'),
            farmName: (FARMS && FARMS.get(data.farmUuid)) ? FARMS.get(data.farmUuid).get('name') : data.legacyFarmName,
        });
    }

    onClick () {
        let configUrlKey = this.model.getConfig().urlKey;
        let farmUuid = this.model.getFarmUuid() || router.getLastEvent().routeNamedArgs.farmUuid;

        let ACTIONS = {
            TASKS: (payload) => {
                let url = `/farm/${farmUuid}/task`;
                if (payload.sprayingUuids) {
                    SessionStorageUtil.set(SessionStorageUtil.KEY_NAMES.TASKS, [payload.sprayingUuids[0]]);
                }
                if (payload.flightTaskUuids) {
                    SessionStorageUtil.set(SessionStorageUtil.KEY_NAMES.TASKS, [payload.flightTaskUuids[0]]);
                }
                router.navigateRelativelyToLocaleCode(url);
            },
            STATUS: (payload) => {
                let url = `/farm/${farmUuid}/field/status`;
                if (payload.cropSeasonUuids) {
                    url += `?cropSeason=${payload.cropSeasonUuids[0]}`;
                }

                router.navigateRelativelyToLocaleCode(url);
            },
            FARM_SHARING: () => {
                let url = `/farm/${farmUuid}/settings/farm`;

                router.navigateRelativelyToLocaleCode(url);
            },
            HISTORY: () => {
                let url = `/farm/${farmUuid}/fields`;

                router.navigateRelativelyToLocaleCode(url);
            }
        };

        if (!ACTIONS[configUrlKey]) {
            return console.warn('Can\'t determine notification action', this.model);
        }

        ACTIONS[configUrlKey](this.model.get('payload'));
    }

}


// WEBPACK FOOTER //
// ./shared/view/NavigationBarView/Notifications/NotificationsItemView/NotificationsItemView.js